import React from "react";
import ReactDOM from "react-dom";

import esEs from "antd/lib/locale-provider/es_ES";
import { i18n } from "./assets/libs/i18n";

import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { LocaleProvider } from "antd";
import { Provider } from "react-redux";
import store from "./redux/store";

const resources = {
  es: esEs,
  "es-ES": esEs,
};

ReactDOM.render(
  <LocaleProvider locale={resources[i18n.language]}>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </LocaleProvider>,
  document.getElementById("root")
);
